import { Table, Button, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { message } from 'antd';
import axios from "./../../../services/http";

const TablaUsuario = ({ data, loading, setLoading, GetUsers, EditUser }) => {

    const DeleteUser = async (id) => {
        try {
            setLoading(true);
            const response = await axios.HTTP_POST(`/api/usuarios/${id}`, {});
            message.success(response.data.message);
            GetUsers();
        } catch (e) {
            console.error('Error al eliminar el usuario:', e);
            message.error('Error al eliminar el usuario');
        } finally {
            setLoading(false);
        }
    }

    const columns = [
        {
            title: 'Usuario',
            dataIndex: 'usuario',
            key: 'usuario',
            fixed: 'left',
        },
        {
            title: 'Perfil',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            align: 'center',
            render:((_, item) => 
                <>
                    <div style={{ textAlign: "center" }}>
                        <Button color="primary" variant="filled" className='mr-5' onClick={() => EditUser(item.id)}>
                            <EditOutlined />
                        </Button>
                        <Popconfirm title="¿Quieres eliminar este usuario?" onConfirm={() => DeleteUser(item.id)}>
                            <Button color="danger" variant="filled">
                                <DeleteOutlined />
                            </Button>
                        </Popconfirm>
                    </div>
                </>
            )
        }
    ];

    return (
        <>
            <Table 
                dataSource={data} 
                columns={columns} 
                rowKey="id" 
                loading={loading} 
                scroll={{
                    x: 'max-content',
                }}
            />
        </>
    )
}

export default TablaUsuario;